import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BasicTimePicker from 'giro-react-toolkit/source/TimePicker';
import Browser from 'giro-react-toolkit/source/UtilityFunctions/Browser';
import FormGroup from "../formGroup";

class TimePicker extends Component {
   constructor(props) {
      super(props);

      this.inputRef = React.createRef();
   }

   /**
    * Put the focus on the time picker input
    */
   focus() {
      this.inputRef.current.focus();
   }

   /**
    * renders the DayPicker component
    */
   render() {
      const fieldClassName = Browser.isAndroid() || Browser.isIos() ? "time-picker-dropdown" : "";

      return (
         <FormGroup
            classNames={fieldClassName}
            iconName="time"
            labelId="time-picker-label"
            resourceKey="ReachMapRes.TimeLabelText">
            <BasicTimePicker
               onChange={(e) => this.props.onSelectedTime(e.target.value)}
               value={this.props.selectedTime}
               required={true}
               inputRef={this.inputRef} />
         </FormGroup>
      );
   }
}

TimePicker.propTypes = {
   /**
    * A callback called when a day is selected
    */
   onSelectedTime: PropTypes.func,
   /**
    * Current value of the picklist
    */
   selectedTime: PropTypes.string
}

export default TimePicker;
